// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8db2e02f","455":"893cf2f5","977":"8edf7dba"}[chunkId] + ".chunk.js";
};